<template>
  <button @click="$emit('handle:click')" :class="color">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'IconButton',
  props: {
    color: {
      type: String,
      default: 'primary',
    },
  }
}
</script>

<style lang="scss" scoped>
button {
  all: unset;
  cursor: pointer;

  &.danger {
    color: #E91D23;
  }

  &.success {
    color: #20c9967e;
  }

  &.primary {
    color: #1C2D5A;
  }

  &.secondary {
    color: #FFC20E;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
}
</style>